export type NotificationSettingsAttributesDto = {
    preApprovedQuote: boolean
    quoteCreatedPriceList: boolean
    invoiceCreatedPriceList: boolean
    preDeclinedQuote: boolean
    signedDocument: boolean
    sentPayment: boolean
    newConversation: boolean
    newSms: boolean
    openedQuote: boolean
    orderAssigned: boolean
    orderLineAssigned: boolean
}

export default class NotificationSettings implements NotificationSettingsAttributesDto {
    preApprovedQuote: boolean
    quoteCreatedPriceList: boolean
    invoiceCreatedPriceList: boolean
    preDeclinedQuote: boolean
    sentPayment: boolean
    newConversation: boolean
    newSms: boolean
    openedQuote: boolean
    signedDocument: boolean
    orderAssigned: boolean
    orderLineAssigned: boolean
    constructor(notificationSettings: NotificationSettingsAttributesDto) {
        this.preApprovedQuote = !!notificationSettings.preApprovedQuote
        this.quoteCreatedPriceList = !!notificationSettings.quoteCreatedPriceList
        this.invoiceCreatedPriceList = !!notificationSettings.invoiceCreatedPriceList
        this.preDeclinedQuote = !!notificationSettings.preDeclinedQuote
        this.sentPayment = !!notificationSettings.sentPayment
        this.newConversation = !!notificationSettings.newConversation
        this.newSms = !!notificationSettings.newSms
        this.openedQuote = !!notificationSettings.openedQuote
        this.signedDocument = notificationSettings.signedDocument
        this.orderAssigned = notificationSettings.orderAssigned
        this.orderLineAssigned = notificationSettings.orderLineAssigned
    }
}


// WEBPACK FOOTER //
// ./src/state/user/NotificationSettings.ts